/**
 * Procurement Demo — the routes Nami is available on.
 *
 * THROWAWAY DEMO CODE. Matches the route table in the procurement demo README
 * (the new Pillar pages plus the three pre-existing ones in the same nav group).
 * Deliberately excludes other `/procurement/*` pages that register their own
 * agent module (for example the query builder), so the two never fight over the
 * single module slot.
 */

const PROCUREMENT_DEMO_PATH_PREFIXES = [
  '/procurement/overview',
  '/procurement/requests',
  '/procurement/suppliers',
  '/procurement/materials',
  '/procurement/sourcing',
  '/procurement/contracts',
  '/procurement/forecast',
  '/procurement/replenishment/board',
  // The old Replenishment and Buyer board addresses redirect to the one above.
  '/procurement/buyer-board',
  '/procurement/demo',
  '/procurement/purchase-orders',
  '/procurement/invoice-compliance',
  '/procurement/agents',
];

export function isProcurementDemoPath(pathname: string): boolean {
  return PROCUREMENT_DEMO_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
